export default function focusOn($timeout) {
  'ngInject';

  return function link(scope, elem, attr) {
    scope.$on('focusOn', (e, name) => {
      if (name === attr.focusOn) {
        $timeout(() => {
          elem[0].focus();
        });
      }
    });
  };
}
